export const ADMIN_EMAIL = 'sam.ghanem@vacatia.com'

export const PROPERTIES = [
  'Berkley Las Vegas',
  'Berkley Orlando',
  'Berkshires Mountain Lodge',
  'Bonaventure / VV @ Weston',
  'Canada House',
  'Grand Lakes / LOVO',
  'Mizner Place at Weston',
  'Palm Beach Shores',
  'The Cliffs at Peace Canyon',
  'The Grandview',
  'The Patriots Inn',
  'Villas at Fortune Place',
  'VV @ Parkway',
  'VV @ The Berkshires',
  'VV @ Williamsburg',
  'Corporate / Support Team',
  'Resort Ops Leadership',
  'Other',
]

export const MODULES = [
  {
    number: '01',
    title: 'Orientation & Enrollment',
    description: 'We formally open Vacatia University, walk each GM through their individual property summary from June, and introduce the Course Packet - the intake document that kicks off everything that follows.',
    prework: [
      'Do a quick mental inventory of your current printed marketing materials',
      'Reflect on your three June commitments and where they stand today',
      'Note one thing you want to bring to the group on the call',
      'Confirm you have the calendar invite and Google Meet link',
    ],
    resources: ['course_packet'],
  },
  {
    number: '02',
    title: 'Collateral Audit & Property in a Box',
    description: 'GMs submit one sample of every marketing piece currently in use at their property. We catalog what exists across the portfolio and begin building the Property in a Box - a standardized resource library every Vacatia property will receive.',
    prework: [
      'Gather one sample of every printed marketing piece currently in use at your property',
      'Ship originals or photograph each piece clearly',
      'Label every item with your property name',
      'Note your biggest collateral pain point - what do you run out of most?',
    ],
    resources: [],
  },
  {
    number: '03',
    title: 'Signage, Uniforms & Brand Standards',
    description: 'GMs complete a full property signage audit - photos, measurements, and condition for every sign interior and exterior. Uniform standards by department are introduced alongside ordering guidance and a phased rollout framework.',
    prework: [
      'Photograph every sign at your property - interior and exterior',
      'Measure each sign (height x width) and note the material if known',
      'Name each photo: Location-Type-Number (e.g. Pool-Entrance-Sign-01)',
      'Complete uniform inventory by department - what staff currently wear',
    ],
    resources: [],
  },
  {
    number: '04',
    title: 'Brand Bible & Voice',
    description: 'A working draft of the Vacatia brand bible is shared with the group for real feedback. GMs are contributors, not recipients. Front desk scripting rooted in the brand voice is introduced and refined together.',
    prework: [
      'Review the Brand Bible in your Resource Library before this session',
      'Note any language your team already uses that feels on-brand',
      'Identify one thing missing from the brand bible for your property type',
      'Think about your front desk scripting - what is working, what is not',
    ],
    resources: ['brand_resources'],
  },
  {
    number: '05',
    title: 'Club Vacatia - Telling the Story',
    description: 'We equip every GM to confidently tell the Club Vacatia story to their boards, owners, and front desk teams. Approved talking points, collateral tools, and QR codes for virtual sales bookings are delivered at this session.',
    prework: [
      'Think about how you currently explain Club Vacatia to owners or boards',
      'Note the questions or objections you hear most often',
      'Identify who at your property currently tells the Club Vacatia story',
      'Think about what materials or tools would make this conversation easier',
    ],
    resources: [],
  },
  {
    number: '06',
    title: 'Guest Experience & OTA Review',
    description: 'We check in on the commitments GMs made in June. OTA accuracy progress is reviewed across the portfolio. The HEAT framework rollout at The Cliffs at Peace Canyon is used as a live peer example of what implementation looks like.',
    prework: [
      'Complete your updated OTA audit - what has been corrected since June',
      'Prepare proof of one commitment made in June (photo, script, team update)',
      'Review your current OTA listings on all channels',
      'Note what you still need to cross the finish line before the retreat',
    ],
    resources: [],
  },
  {
    number: '07',
    title: 'Owner Communication & Department Enrollment',
    description: 'We go deep on owner communication frameworks and take a full read on where brand enrollment stands across every department at every property. The goal is to close open loops before the final session.',
    prework: [
      'Update your department enrollment map (Living It / Getting There / Not Yet)',
      'Draft one owner communication you will send within 7 days of this call',
      'List any open items you need resolved before graduation',
      'Review the Brand Voice Guide for owner communication language',
    ],
    resources: ['brand_resources'],
  },
  {
    number: '08',
    title: 'Graduation & Retreat Prep',
    description: 'This is graduation. Eight modules, real deliverables at every property. This session closes Curriculum 01 and opens the in-person Leadership Retreat - which goes deeper because the foundational work is already done.',
    prework: [
      'Complete your final department enrollment map',
      'Prepare one thing you want to celebrate from the past several months',
      'Write down your open questions for the retreat',
      'Review everything in your Resource Library - this is your toolkit going forward',
    ],
    resources: ['brand_resources'],
  },
]

export const RESOURCES = {
  course_packet: {
    id: 'course_packet',
    title: 'Course Packet - Property Intake',
    description: 'Your intake document - collateral inventory, signage audit, uniform inventory, brand enrollment check, and open questions. Due before Module 2 on November 18.',
    icon: '📋',
    link: 'https://drive.google.com/file/d/13SXlHNfXXcAGvk07CZsQSr25SYWa6sFD/view?usp=drivesdk',
    type: 'word_doc',
  },
  brand_resources: {
    id: 'brand_resources',
    title: 'Vacatia Brand Resources',
    description: 'The live folder Sam keeps current - Brand Bible, Brand Guide, and Brand Voice Guide, always up to date.',
    icon: '📁',
    link: 'https://drive.google.com/drive/folders/1PpBE_5oZ-25ymoMoTt2J5g15RUOugbFV?usp=drive_link',
    type: 'google_drive_folder',
  },
}

export const RECORDINGS_FOLDER = 'https://drive.google.com/drive/folders/1ZkHCHKg9O_w45kiruzNHaE-LhlPtm8sr'
export const RESOURCES_FOLDER = 'https://drive.google.com/drive/folders/1q5iJDt2KLvfsMLoD7t-BeJQ9xajvun8B'
export const CLAUDE_PROJECT_LINK = 'https://claude.ai/project/019fae26-8526-7507-a02a-7af7b5cdf2b9'

export const BRAND_VOICE_PROMPT = `You are the Vacatia brand voice assistant. Your job is to help Vacatia General Managers and property teams communicate in a way that is on-brand, warm, and professional.

Vacatia's voice is the "Warm Optimist with Taste" - confident but never arrogant, warm but never saccharine, smart but never showing off. 

Before writing anything, ask: does this feel first and explain second?

Every message should:
- Open with feeling (anticipation, warmth, acknowledgment) before logistics
- Center what the guest or owner gets to experience, not what Vacatia is excited to offer
- Stay clear, human, and calm - short-to-medium sentences, plain language over jargon
- Never be pushy or clinical
- Close with a real name, not a generic sign-off

If the request touches something operational (check-in times, property specifics, pricing), note that those details should be confirmed with the property before sending - your job is voice, not fact-checking.

Picture a warm, capable friend who happens to run a great hospitality company. That is the voice.

When the user gives you a situation or a draft to improve, respond with:
1. The on-brand version of what they need
2. One brief note on what you adjusted and why (keep this short - one or two sentences max)

Keep responses concise and usable. These are busy people.`

// Recording management - admin adds these per module after each session
// Structure: { moduleNumber, recordingUrl, sessionDate, sessionTitle, published }
// Stored in Supabase recordings table
